import Vue from "vue";
import Router from "vue-router";
import core from "@/core";
import store from "@/store";

const NotFound = () => import("@/views/errors/NotFound");
const NotSupportBrowser = () => import("@/views/errors/NotSupportBrowser");

// Containers
const TheContainer = () => import("@/containers/TheContainer");

// Views
const SelectCrop = () => import("@/views/SelectCrop");
const TomatoDiseaseAnalysis = () => import("@/views/TomatoDiseaseAnalysis");
const StrawberryDiseaseAnalysis = () => import("@/views/StrawberryDiseaseAnalysis");
const PaprikaDiseaseAnalysis = () => import("@/views/PaprikaDiseaseAnalysis");
const DiseaseRequestAdd = () => import("@/views/DiseaseRequestAdd");

Vue.use(Router);

const routes = [
  {
    path: "*",
    name: "notFound",
    component: NotFound,
    meta: {
      title: "병해충 영상진단",
    },
  },
  {
    path: "/error/not-support-browser",
    name: "notSupportBrowser",
    component: NotSupportBrowser,
    meta: {
      title: "병해충 영상진단",
    },
  },
  {
    path: "/analysis/disease",
    name: "병해충 영상진단 작물 선택",
    component: SelectCrop,
    meta: {
      title: "병해충 영상진단 - 작물 선택",
    },
  },
  {
    path: "/",
    redirect: "/analysis/disease",
    name: "Home",
    component: TheContainer,
    meta: {
      title: "병해충 영상진단",
    },
    children: [
      {
        path: "analysis",
        redirect: "/analysis/disease",
        name: "데이터 분석",
        meta: {
          title: "병해충 영상진단",
        },
        component: {
          render(c) {
            return c("router-view");
          },
        },
        children: [
          {
            path: "disease/tomato",
            name: "병해충 영상진단(토마토)",
            component: TomatoDiseaseAnalysis,
            meta: {
              title: "병해충 영상진단(토마토)",
            },
          },
          {
            path: "disease/strawberry",
            name: "병해충 영상진단(딸기)",
            component: StrawberryDiseaseAnalysis,
            meta: {
              title: "병해충 영상진단(딸기)",
            },
          },
          {
            path: "disease/paprika",
            name: "병해충 영상진단(파프리카)",
            component: PaprikaDiseaseAnalysis,
            meta: {
              title: "병해충 영상진단(파프리카)",
            },
          },
          {
            path: "disease/robot",
            name: "로봇방제시스템",
            component: () => import("@/views/RobotDiseaseAnalysis.vue"),
            meta: {
              title: "로봇방제시스템",
            },
          },
        ],
      },

      {
        path: "/analysis/disease/request",
        redirect: "/analysis/disease/request",
        name: "병해충 분석요청",
        component: {
          render(c) {
            return c("router-view");
          },
        },
        children: [
          // {
          //   path: "",
          //   name: "목록",
          //   component: DiseaseRequest,
          //   meta: {
          //     title: "병해충 분석요청 - 목록",
          //     roles: ["manager"],
          //   },
          // },
          {
            path: "",
            name: "등록",
            component: DiseaseRequestAdd,
            meta: {
              title: "병해충 분석요청 등록",
              roles: ["manager"],
            },
          },
          // {
          //   path: "edit",
          //   name: "수정",
          //   component: DiseaseInfoAddEdit,
          //   meta: {
          //     title: "병해충 영상진단 - 병해충 정보 수정",
          //     roles: ["manager"],
          //   },
          // },
        ],
      },
    ],
  },
];

const router = new Router({
  mode: "history", // https://router.vuejs.org/api/#mode
  linkActiveClass: "active",
  scrollBehavior: () => ({ y: 0 }),
  routes: routes,
});

function childrenRouteMap(path, children) {
  children.forEach((data) => {
    let slash = "";
    if (path.substr(path.length - 1, path.length) !== "/") {
      slash = "/";
    }
    const _path = path + slash + data.path;
    if (data.children != null) {
      childrenRouteMap(_path, data.children);
    } else {
      if (routeMap.get(_path) != null) {
        console.log("중복 path : ", _path);
      }
      routeMap.set(_path, data);
    }
  });
}

const routeMap = new Map();
routes.forEach((data) => {
  if (data.children != null) {
    childrenRouteMap(data.path, data.children);
  } else {
    if (routeMap.get(data.path) != null) {
      console.log("중복 path : ", data.path);
    }
    routeMap.set(data.path, data);
  }
});

const routerBeforeTask = store.state.routerBeforeTask;
router.beforeEach(async (to, from, next) => {
  if (!routerBeforeTask.isRouterNext()) {
    //console.log("ignore router event");
    next(false);
    return;
  } else {
    const viewerContainer = document.querySelector(
      ".viewer-container.viewer-in",
    );
    if (viewerContainer != null) {
      next(false);
      const button = viewerContainer.querySelector(".viewer-button");
      if (button != null) {
        button.click();
      }
      return;
    }
  }

  //console.log("from   : ", from);
  //console.log("to     : ", to);
  core.loader.show("페이지 로딩중...");

  // console.log("from " + from.path + " -> to : " + to.path);
  document.title = await beforeEach(to, from, next);
  core.loader.hide();
});

async function beforeEach(to, from, next) {
  next();
  if (to.meta != null && to.meta.title != null) {
    return to.meta.title;
  } else {
    return "";
  }
}

export default router;
